import { InputTypes } from "@/types/form.types";
import { Variations } from "@/types/product.types";

//----------------- PRODUCT VARIATIONS -----------------
export const NUMBER_OF_VARIATIONS = 5;

//----------------- CATEGORY HIERARCHY -----------------
export const MAX_CATEGORY_HIERARCHY_LEVEL = 4;

export const VARIANT_INPUT_TYPES: Record<Variations, InputTypes> = {
  color: "string",
  size: "select",
  weight: "number",
  material: "string",
  volts: "string",
  capacity: "string",
  model: "string",
  version: "string",
};

export const SIZE_OPTIONS = [
  { value: "P", label: "P" },
  { value: "M", label: "M" },
  { value: "G", label: "G" },
];
